import styled from 'styled-components';

import { colorPrimary, colorSecondary, colorAccent } from 'styles';

export const Path = styled.path`
  fill: ${({ gradientId }) => (gradientId ? `url(#${gradientId})` : 'none')};
  stroke: ${({ type, color }) => {
    if (type === 'area') {
      return 'none';
    }

    switch (color) {
      case 'secondary':
        return colorSecondary;
      case 'blue':
        return colorAccent;
      case 'yellow':
        return '#E7A600';
      case 'violet':
        return '#AF1CC9';
      case 'gray':
        return '#ECECEC';
      case 'primary':
      default:
        return colorPrimary;
    }
  }};
  stroke-width: 2;
`;

export default Path;
